// extracted by mini-css-extract-plugin
export var social = "style_social__PMrfM";
export var footer = "style_footer__K3vC0";
export var socialLink = "style_social_link__zsD4Y";
export var rotate = "style_rotate__Rf9CY";
export var dotty = "style_dotty__32FF2";